import { getToken } from "./user-service";
import fire from "_utils/firebase";
const url = "/api/v1/marketplace";

export const updateProduct = async (params) => {
  const new_url = "/api/v1/marketplace/products/" + params.id;

  const token = await getToken();
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "PUT",
        body: JSON.stringify(params.body),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });

      let json = await response.json();

      if (response.status >= 400) {
        // bad request invalid fields
        throw new Error(
          "Issue creating a reward using the details you provided."
        );
      }
      if (response.status >= 500) {
        // network error
        throw new Error(
          "Issue with network connection, please try again later."
        );
      }

      resolve(json);
    } catch (e) {
      reject(e);
    }
  });
};;

export const createProduct = async (product) => {
  const new_url = "/api/v1/marketplace/products/create";

  const token = await getToken();

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(new_url, {
        method: "POST",
        body: JSON.stringify(product),
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });
      let json = await response.json();

      if (response.status >= 400) {

        // bad request invalid fields
        console.log('response', json.errors[0].msg);
        if (json != undefined && json.errors != undefined && json.errors[0] != undefined && json.errors[0].msg != undefined) {
          if (json.errors[0].msg == 'Document update conflict.') {
            throw new Error("Product with identical name from same retailer exsists, please change either the product name or retailer name to create the product.")
          }
        }

        throw new Error(
          "Issue creating a reward using the details you provided."
        );
      }
      if (response.status >= 500) {
        // network error
        throw new Error(
          "Issue with network connection, please try again later."
        );
      }

      console.log('response', json)
      resolve(json);

    } catch (e) {
      reject(e);
    }
  });
};

export const getUserMarketplaceProducts = async (retailerId) => {

  // create url for products list
  const getProductsUrl = url + "/products/productsByRetailerId/" + retailerId;

  return new Promise(async (resolve, reject) => {
    try {

      const response = await fetch(getProductsUrl, {
        method: "GET",
        headers:
        {
          "Firebase-UID": '123456789',
          "Content-Type": "application/json",
          "accept": "application/json"
        },
      });

      let json = await response.json();

      //console.log('getProductsUrl response:', json);

      if (response.status >= 400 && response.status < 600) {
        throw ('error getting payment intent...', response)
      }

      resolve(json);

    } catch (e) {
      reject(new Error(e));
    }
  });
};

export const getFirebaseProducts = async (retailerId) => {

  // create url for products list
  const getProductsUrl = url + "/products/firebaseProducts/" + retailerId;

  return new Promise(async (resolve, reject) => {
    try {

      const response = await fetch(getProductsUrl, {
        method: "GET",
        headers:
        {
          "Firebase-UID": '123456789',
          "Content-Type": "application/json",
          "accept": "application/json"
        },
      });

      let json = await response.json();

      //console.log('getProductsUrl response:', json);

      if (response.status >= 400 && response.status < 600) {
        throw ('error getting payment intent...', response)
      }

      resolve(json);

    } catch (e) {
      reject(new Error(e));
    }
  });
};
